import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const OffersList = (props) => {
 
    const [offers, setOffers] = useState([])

    useEffect(() => {
        apiGet(`intranetoffers/getalloffers`).then(res => {
        res.json().then(data => {
            setOffers(data.results)
        })
        })
    }, [])


    const updateOffers = (e) => {
        console.log("u")
        props.setUpdateOrCreate("u")
        props.setId(e.target.value)
    }

    const createOffer = () => {
      props.setUpdateOrCreate("c")
  }

  const deleteOffer = (e) => {
    console.log(e.target.value)
    apiDelete(`intranetoffers/deleteoffer`, {id: e.target.value})
  .then(response => {if(response.ok){
    apiGet(`intranetoffers/getalloffers`).then(res => {
        res.json().then(data => {
            setOffers(data.results)
        })
        })
  }
  })
}
    {console.log(offers)}
    return (
        <>
          <Container>
            <Row>
                <h1>Member Offers</h1>
            </Row>
            <Row>
                <Col>
                    <Form>
                    <a href={`https://business-butler-intranet.herokuapp.com/`} className="btn btn-primary">
                        Home Page
                    </a>
                    <Button onClick={(event) => createOffer(event)} className="btn btn-primary">
                        Create New
                    </Button>
                    </Form>
                </Col>
            </Row>
                <div className="section">
                  {offers.map(offer => {
                    return (
                      <Row style={{paddingBottom:"10px"}}>
                          <Col md={1}>{offer.id}</Col>
                          <Col md={3}>{offer.company}</Col>
                          <Col md={4}>{offer.headline}</Col>
                          <Col md={1}>{offer.published ? "Published": "Not Published"}</Col>
                          <Col md={3}>
                            <Button onClick={(event) => updateOffers(event)} value={offer.id} className="btn btn-primary">
                              Edit
                            </Button>
                            <Button onClick={(event) => deleteOffer(event)} value={offer.id} className="btn btn-primary">
                              Delete
                            </Button>
                          </Col>
                      </Row>
                      
                    )
                  })}
                </div>
            
            </Container>
        </>
      );

}

export default OffersList;